import React from 'react';
import { createPortal } from 'react-dom';
import '../../styles/modal.css';

const CreateTestCaseOptionsModal = ({
  isOpen,
  onClose,
  onCreateTestCase,
  onCreateViaExtension,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div data-rt-modal-overlay className="create-test-case-options-modal-overlay" onClick={onClose}>
      <div
        className="create-test-case-options-modal-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="create-test-case-options-modal-header">
          <h2>Create Test Case</h2>
          <p>Choose how you want to create a new test case</p>
        </div>

        <div className="create-test-case-options-modal-body">
          <button
            type="button"
            onClick={() => {
              onCreateTestCase();
              onClose();
            }}
            className="create-test-case-option-btn"
          >
            <div className="create-test-case-option-btn-inner">
              <div className="create-test-case-option-icon manual">
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  stroke="#2563eb"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </div>
              <div>
                <h3 className="create-test-case-option-title">Create Manually</h3>
                <p className="create-test-case-option-desc">
                  Manually enter test case details using the form
                </p>
              </div>
            </div>
          </button>

          <button
            type="button"
            onClick={() => {
              onCreateViaExtension();
              onClose();
            }}
            className="create-test-case-option-btn extension"
          >
            <div className="create-test-case-option-btn-inner">
              <div className="create-test-case-option-icon extension">
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  stroke="#16a34a"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div>
                <h3 className="create-test-case-option-title">Record with Extension</h3>
                <p className="create-test-case-option-desc">
                  Use the browser extension to record your interactions
                </p>
              </div>
            </div>
          </button>
        </div>

        <div className="create-test-case-options-modal-footer">
          <button
            type="button"
            onClick={onClose}
            className="create-test-case-options-cancel-btn"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CreateTestCaseOptionsModal;
